<div class="tw-relative tw-flex tw-items-center">
  <span class="tw-truncate tw-block tw-pr-6">{{ value }}</span>
</div>
